module.exports = __webpack_public_path__ + "img/2022-04-01.aa77a591.jpg";